import { render, staticRenderFns } from "./OperaProjectLabelListWindow.vue?vue&type=template&id=a015184a&scoped=true&"
import script from "./OperaProjectLabelListWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectLabelListWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectLabelListWindow.vue?vue&type=style&index=0&id=a015184a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a015184a",
  null
  
)

export default component.exports